// generated by genversion
const version = '6.15.3';

export { version };
//# sourceMappingURL=version.mjs.map
